import React, { useState } from "react";

export interface InviteUserModalProps {
  onClose: () => void;
  onInviteUser: (email: string) => void;
}

const InviteUserModal: React.FC<InviteUserModalProps> = ({ onClose, onInviteUser }) => {
  const [email, setEmail] = useState("");

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      inviteUserEmail();
    }
  };

  const isValidEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const inviteUserEmail = () => {
    onInviteUser(email);
  };

  return (
    <div
      className="primary-input-container"
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <h2>Invite user</h2>

      <div style={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}>
        <label htmlFor="to-address">To:</label>
        <input
          id="email"
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="example@example.com"
          className="url-input"
          onKeyDown={handleKeyPress}
        />
        <button
          className="primary-button"
          style={{
            opacity: isValidEmail(email) ? 1 : 0.6,
          }}
          onClick={inviteUserEmail}
          disabled={!isValidEmail(email)}
        >
          Send
        </button>
        <button className="tertiary-button" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default InviteUserModal;
